var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('order-navigation-drawer',{staticStyle:{"position":"fixed","top":"60px","left":"0"}}),_c('div',{staticStyle:{"position":"absolute","left":"240px","right":"0"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }